import { render, staticRenderFns } from "./confirmItem.vue?vue&type=template&id=5765d57b&"
import script from "./confirmItem.vue?vue&type=script&lang=js&"
export * from "./confirmItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports